import PhotoSwipe from '../../assets/vendor/photoswipe/photoswipe.esm.min.js';
import PhotoSwipeLightbox from '../../assets/vendor/photoswipe/photoswipe-lightbox.esm.min.js';

function addWpImageSizeFilter(lightbox) {
  lightbox.addFilter('domItemData', (itemData, element, linkEl) => {
    if (itemData?.w && itemData?.h) return itemData;

    const anchor = linkEl || (element?.tagName === 'A' ? element : element?.querySelector?.('a'));
    const img = anchor?.querySelector?.('img') || element?.querySelector?.('img');
    if (!img) return itemData;

    const href = anchor?.dataset?.pswpSrc || anchor?.href || '';
    const displayedSrc = img.currentSrc || img.src || '';

    // If URL contains dimensions like `image-1200x800.jpg`, prefer that.
    const urlSizeMatch = href.match(/-(\d{2,5})x(\d{2,5})(?=\.[a-zA-Z]{2,5}(?:$|\?))/);
    if (urlSizeMatch) {
      const w = parseInt(urlSizeMatch[1], 10);
      const h = parseInt(urlSizeMatch[2], 10);
      if (w && h) {
        itemData.w = w;
        itemData.h = h;
        itemData.width = w;
        itemData.height = h;
        return itemData;
      }
    }

    // Otherwise infer size from the displayed image.
    // IMPORTANT: In classic WP galleries the displayed <img> is a small thumbnail,
    // but <a href> points to a larger file. If we use thumbnail dimensions,
    // PhotoSwipe will render the slide as a tiny image.
    const widthAttr = img.getAttribute('width');
    const heightAttr = img.getAttribute('height');
    let width = widthAttr ? parseInt(widthAttr, 10) : 0;
    let height = heightAttr ? parseInt(heightAttr, 10) : 0;

    if ((!width || !height) && img.naturalWidth && img.naturalHeight) {
      width = img.naturalWidth;
      height = img.naturalHeight;
    }

    const linkDiffersFromThumb = href && displayedSrc && href !== displayedSrc;
    if (linkDiffersFromThumb && width && height) {
      // Scale thumbnail dimensions up to a reasonable baseline (keeps aspect ratio).
      const minTargetWidth = 1600;
      const scale = Math.max(1, minTargetWidth / width);
      width = Math.round(width * scale);
      height = Math.round(height * scale);
    }

    if (width && height) {
      itemData.w = width;
      itemData.h = height;
      itemData.width = width;
      itemData.height = height;
    }

    return itemData;
  });
}

function createLightbox(gallery, children = 'a') {
  const lightbox = new PhotoSwipeLightbox({
    gallery,
    children,
    pswpModule: PhotoSwipe
  });

  addWpImageSizeFilter(lightbox);
  lightbox.init();
}

function initPhotoSwipe() {
  const galleryBlocks = document.querySelectorAll('.wp-block-gallery');
  const classicGalleries = Array.from(document.querySelectorAll('.gallery')).filter(
    (el) => !el.classList.contains('wp-block-gallery') && !el.closest('.wp-block-gallery')
  );
  const standaloneImages = Array.from(document.querySelectorAll('.wp-block-image')).filter(
    (el) => !el.closest('.wp-block-gallery, .gallery')
  );

  if (!galleryBlocks.length && !classicGalleries.length && !standaloneImages.length) return;

  // Gallery navigation (prev/next) works within each `.wp-block-gallery`.
  // Only anchors inside `.wp-block-image` become slides.
  if (galleryBlocks.length) {
    createLightbox(galleryBlocks, '.wp-block-image a');
  }

  // Classic WordPress galleries created by the [gallery] shortcode / Classic Editor.
  // Typical markup: .gallery -> figure.gallery-item -> a -> img
  if (classicGalleries.length) {
    createLightbox(classicGalleries, '.gallery-item a');
  }

  // Standalone images outside galleries.
  if (standaloneImages.length) {
    createLightbox(standaloneImages, 'a');
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPhotoSwipe, { once: true });
} else {
  initPhotoSwipe();
}
